import "./styles.scss";
import { LocationPage } from "../../js/location-page";

new LocationPage();
